export default "__VITE_ASSET__DQk6wtjG__"